import React, { Component } from "react";
import { connect } from "react-redux";

class ServerErrorModal extends Component {
    render() {
        return <div className="modal fade" id="server-error-modal" tabIndex="-1" role="dialog" aria-labelledby="login-modal" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-body">
                        <div className="row justify-content-center">
                            <div className="col-md-12">
                                <div className="feature feature-1" style={{ minHeight: "3rem" }}>
                                    <div className="text-block">
                                        <h3>Error</h3>
                                        <p id="server-error-msg"></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>;
    }
}

export default connect()(ServerErrorModal);